import { Breadcrumb, SimpleCard } from "@gull";
import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import { Formik } from "formik";
import moment from "moment";
import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Affiliate from "./Components/Offline/Affiliate";
import BookingDetails from "./Components/Offline/BookingDetails";
import {
  OfflineModel,
  validationSchema,
} from "./Components/Offline/Offlinevalid";
import RoomDetails from "./Components/Offline/RoomDetails";
import GuestDetails from "./Components/Offline/GuestDetails";
import HotelDetails from "./Components/Offline/HotelDetails";
import CancellationDetails from "./Components/Offline/CancellationDetails";
import PriceDetails from "./Components/Offline/PriceDetails";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import { offlineTicket } from "app/services/hotel/hotelService";
export default function OfflineBooking() {
  const navigate = useNavigate();
  const [state, setState] = useState(OfflineModel);
  const [isLoading, setIsLoading] = useState(false);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [cancellationPolicy, setCancellationPolicy] = useState(false);
  const priceCalPerRoom = (priceBreakup, value) => {
    const price = {
      BF: priceBreakup.BF / value,
      NF: priceBreakup.NF / value,
      CMU: 0,
      TAF: priceBreakup.TAF / value,
      TF: priceBreakup.TF / value,
    };
    return price;
  };
  const priceCalByDay = (checkInDate, checkOutDate, values) => {
    debugger;
    const start = moment(checkInDate);
    const end = moment(checkOutDate);
    const numOfDays = Math.max(end.diff(start, "days"), 1); // ensure at least 1

    const differenceInMilliseconds = start - end;
    // Convert milliseconds to days
    const nights = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    const dailyPis = Array.from({ length: numOfDays }, (_, i) => {
      const day = i + 1;

      return {
        day: day.toString(),
        fc: {
          BF:
            Math.abs(values.price?.BF / values.roomDetails.length / nights) ??
            0,
          NF:
            Math.abs(values.price?.NF / values.roomDetails.length / nights) ??
            0,
          TF:
            Math.abs(values.price?.TF / values.roomDetails.length / nights) ??
            0,
          CMU: 0,
          TAF:
            Math.abs(values.price?.TAF / values.roomDetails.length / nights) ??
            0,
        },
        afc: {
          TAF: {
            MF: 0,
            SBP: 0,
            PRF: 0,
            SNP: 0,
            MFT: 0,
            SRC: 0,
            IGST: 0,
            SGP: 0,
            TTSF: 0,
            SAC: 0,
            TMF: 0,
            TSF: 0,
          },
        },
      };
    });

    return dailyPis;
  };

  const benefitsCreation = (values) => {
    if (values.includes(",")) {
      const request = {
        BENEFIT: [
          {
            values: values
              .split(",")
              .map((b) => b.trim())
              .filter(Boolean), // returns an array
          },
        ],
      };
      return request;
    }
  };

  const submitForm = async (values) => {
    setIsLoading(true);

    if (values.memId) {
      const bookingResponse = {
        order: {
          bookingId: values.bookingId,
          amount: values.price.TF,
          markup: 0,
          deliveryInfo: {
            emails: [""],
            contacts: [""],
            code: ["+91"],
          },
          status: "PAYMENT_SUCCESS",
          createdOn: `${moment().format("YYYY-MM-DD")}T${moment().format(
            "HH:mm:ss",
          )}`,
        },
        itemInfos: {
          HOTEL: {
            hInfo: {
              name: values?.hotelName,
              des: values.des,
              rt: values.rating,
              gl: values.gl,
              ad: values.address,
              cnt: values.cnt,
              inst: [],
              ops: [
                {
                  ris: values.roomDetails.map((roomSeg, index) => ({
                    id: index,
                    rc: roomSeg?.rc,
                    rt: roomSeg?.rc,
                    srn: roomSeg?.rc,
                    adt: roomSeg?.adt,
                    chd: roomSeg?.chd,
                    mb: roomSeg?.mb,
                    tp: values.price.TF / values.roomDetails.length,
                    tfcs: priceCalPerRoom(
                      values.price,
                      values.roomDetails.length,
                    ),
                    ddt: values.ddt,
                    pis: priceCalByDay(
                      values?.CheckInDate,
                      values?.CheckOutDate,
                      values,
                    ),
                    checkInDate: moment(values?.CheckInDate).format(
                      "YYYY-MM-DD",
                    ),
                    checkOutDate: moment(values?.CheckOutDate).format(
                      "YYYY-MM-DD",
                    ),
                    ti: roomSeg?.ti,
                    ispfap: false,
                    iopr: false,
                    radi: {
                      rid: "216348277",
                      mga: 2,
                      maa: 2,
                      mca: 1,
                      bds: [
                        {
                          bt: "Double",
                          bc: 1,
                        },
                      ],
                    },
                    rexb: benefitsCreation(roomSeg.rexb),
                  })),
                  tp: values.price.TF,
                  sc: "INR",
                  ...(cancellationPolicy && {
                    cnp: {
                      id: values.cancellation.id,
                      ifra: false,
                      inra: true,
                      pd: values.cancellation.pd.map((canSeg, index) => ({
                        fdt: canSeg?.fdt,
                        tdt: canSeg?.tdt,
                        am: canSeg?.am ?? 0,
                        pp: 0,
                      })),
                      cpb: 48,
                    },
                  }),
                  ddt: `${moment().format("YYYY-MM-DD")}T${moment().format(
                    "HH:mm:ss",
                  )}`,
                  inst: [],
                },
              ],
              uid: "16159064",
            },
            query: {
              checkinDate: moment(values?.CheckInDate).format("YYYY-MM-DD"),
              checkoutDate: moment(values?.CheckOutDate).format("YYYY-MM-DD"),
              roomInfo: values.roomInfo,
              searchCriteria: values.searchCriteria,
              searchPreferences: {
                currency: "INR",
              },
              isSearchCompleted: false,
            },
          },
        },
        gstInfo: {},
        currentTime: `${moment().format("YYYY-MM-DD")}T${moment().format(
          "HH:mm:ss",
        )}`,
        status: {
          success: true,
          httpStatus: 200,
        },
      };

      const request = {
        memId: values.memId,
        bookingId: values.bookingId,
        roomTravellerInfo: values.roomDetails.map((roomSeg, index) => ({
          travellerInfo: roomSeg.ti,
        })),

        deliveryInfo: {
          emails: [""],
          contacts: [""],
          code: ["+91"],
        },
        type: "HOTEL",
        paymentInfos: [
          {
            amount: values.price.NF,
          },
        ],
        hotelReviewResponse: "",
        hotelBookingResponse: JSON.stringify(bookingResponse),
        cityId:
          values.cityId != "" ? Number(values.searchCriteria.cityId) : 650088,
        countryId: values.searchCriteria.countryId
          ? Number(values.searchCriteria.countryId)
          : 207,
        userMarkup: values.userMarkup,
        adminMarkup: values.adminMarkup,
        roomNo: values.roomInfo.length,
        checkInDate: moment(values?.CheckInDate).format("YYYY-MM-DD"),
        checkOutDate: moment(values?.CheckOutDate).format("YYYY-MM-DD"),
        hotelName: values.hotelName,
        hotelId: 1,
        hsnNo: values.hsnNumber.toString(),
      };
      // console.log(bookingResponse);
      try {
        const res = await offlineTicket(request);
        if (res.status == "Success") {
          navigate("/admin/hotel/booking-history");
          NotificationManager.success(res.message);
        } else {
          NotificationManager.error("Something went wrong");
        }
      } catch (error) {
        console.error("Submission Error:", error);
        NotificationManager.error("Error submitting form");
      }
      setIsLoading(true);
    } else {
      NotificationManager.error("Select Member");
    }
  };
  const handleCheckboxChange = (e) => {
    setCancellationPolicy(e.target.checked);
  };
  return (
    <div>
      <Helmet>
        <title>Offline Hotel Booking</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Offline Hotel Booking" }]}
      ></Breadcrumb>
      <Formik
        onSubmit={submitForm}
        initialValues={state}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <>
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                <SimpleCard className="mb-2" title="Affiliate">
                  <Affiliate
                    values={values}
                    setFieldValue={setFieldValue}
                    setState={setState}
                    errors={errors}
                    touched={touched}
                    state={state}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                  />
                </SimpleCard>
                <SimpleCard className="mb-2" title="Booking Details">
                  <BookingDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                  />
                </SimpleCard>
                <SimpleCard className="mb-2" title="Hotel Details">
                  <HotelDetails
                    setIsManualEntry={setIsManualEntry}
                    isManualEntry={isManualEntry}
                    values={values}
                    setFieldValue={setFieldValue}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                  />
                </SimpleCard>

                <SimpleCard className="mb-2" title="Room Details">
                  <RoomDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    setState={setState}
                  />
                </SimpleCard>
                <SimpleCard className="mb-2" title="Guest Details">
                  <GuestDetails
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    handleBlur={handleBlur}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    setState={setState}
                  />
                </SimpleCard>
                <SimpleCard className="mb-2" title="Price Details">
                  <PriceDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    setState={setState}
                    errors={errors}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    touched={touched}
                  />
                </SimpleCard>
                <div className="form-group">
                  <div className="form-check mb-3 ">
                    <input
                      type="checkbox"
                      className="form-check-input red-border-checkbox cursor-pointer"
                      id="cancellationCheck"
                      checked={cancellationPolicy}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      className="form-check-label fw-bold text-danger fs-md cursor-pointer"
                      htmlFor="cancellationCheck"
                    >
                      Add Cancellation Policy
                    </label>
                  </div>

                  {cancellationPolicy && (
                    <SimpleCard className="mb-2" title="Cancellation Policy">
                      <CancellationDetails
                        values={values}
                        setFieldValue={setFieldValue}
                        setState={setState}
                        errors={errors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                      />
                    </SimpleCard>
                  )}
                </div>

                <div className="row mt-4 mb-4">
                  <div className="col-md-12 ">
                    {isLoading ? (
                      <Button variant="primary" disabled>
                        <Spinner animation="border" size="sm" /> Submitting...
                      </Button>
                    ) : (
                      <Button variant="primary" type="submit">
                        Submit Booking
                      </Button>
                    )}
                  </div>
                </div>
              </form>
            </>
          );
        }}
      </Formik>
    </div>
  );
}
